import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Input from 'Components/Input';
import { Button } from 'Components/Button';
import TurnstileWidget from 'Components/TurnstileWidget';
import { errorMap } from 'Components/Input/errorMap';
import { loginUserV2, loginWithCaptcha } from 'Store/actions';
import { FIELD_LENGTHS } from 'Store/constants/sportTypes';
import validateLogin from './validateLogin';
import { isAlphanumeric } from 'Store/constants/featureFlag';
import { toggleCaptchaBadge } from 'Utils/reCaptcha';
import Cookies from 'universal-cookie';
import LottieLoader from 'Components/LottieLoader';
import { withMixpanel } from 'Utils/mixpanel';
import History from 'Store/history';
import qs from 'query-string';
import EnvironmentManager from 'Utils/environmentManager';

const cookies = new Cookies();

class LoginForm extends Component {

  static propTypes = {
    loginUserV2: PropTypes.func,
    loginWithCaptcha: PropTypes.func,
    auth: PropTypes.object,
    // googleReCaptchaProps: PropTypes.object,
    page: PropTypes.bool,
    mixpanel: PropTypes.object,
    location: PropTypes.object,
  };

  constructor (props) {
    super(props);
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    const captchaRequired = !isLocalhost && cookies.get('captchaRequired') === 'true';
    this.state = {
      username: '',
      password: '',
      referenceCode: '',
      validationErrors: {
        username: '',
        password: ''
      },
      captchaRequired: captchaRequired,
      errorFlag: false,
      turnstileToken: '',
      turnstileEnabled: false
    };
    this.turnstileRef = React.createRef();
  }

  componentDidMount () {
    if (this.props?.page) {
      toggleCaptchaBadge(true);
    }

    const referenceCode = this.props.location?.state?.referenceCode;
    const currentQueryParams = qs.parse(this.props.location?.search, { arrayFormat: 'bracket', parseNumbers: true, parseBooleans: true });
    const username = this.props.location?.state?.identifier;
    
    if (referenceCode || currentQueryParams['referans-kod']) {
      this.setState({
        referenceCode: (referenceCode || currentQueryParams['referans-kod']).toUpperCase()
      });
    }

    if (username) {
      this.setState({
        username
      });
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props?.page) {
      toggleCaptchaBadge(true);
    }
    if (prevProps.auth?.captchaRequired !== this.props.auth?.captchaRequired) {
      const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
      if (!isLocalhost) {
        this.setState({
          captchaRequired: true
        });
      }
    }
  }
  
  componentWillUnmount () {
    toggleCaptchaBadge(false);
  }

  onChange = e => {
    const { id, value } = e.target;
    let isValid = true;

    const numberRegex = /^[0-9\b]+$/;

    if (isAlphanumeric.regexControl) {
      if (value !== '') {
        isValid = numberRegex.test(value);
      }
    } else {
      if (value !== '' && id !== 'password') {
        isValid = true;
        if (id === 'username') {
          isValid = numberRegex.test(value);
        }
      }
    }

    if (isValid) {
      this.setState({
        [id]: value,
        validationErrors: {
          ...this.state.validationErrors,
          [id]: ''
        }
      });
    }
  };

  onBlur = e => {
    const { id, value } = e.target;
    const validator = validateLogin({ [id]: value });

    if (!validator.isValid) {
      this.setState({
        validationErrors: {
          ...this.state.validationErrors,
          [id]: validator.errors[id]
        }
      });
    }
  };

  onSubmit = async e => {
    e.preventDefault();
    const trackEvent = true;
    const getLoginForm = true;
    const { username, password, captchaRequired, referenceCode, turnstileToken } = this.state;
  
    // const isReCaptchaEnabled = ProjectConfig.reCaptchaEnabled;

    // Login request body: username, password, referenceCode, captcha (Turnstile token)
    let user = {
      username,
      password,
      ...(turnstileToken ? { captcha: turnstileToken } : {})
    };
    
    /*
    // reCAPTCHA v3 (temporarily disabled)
    if (captchaRequired && isReCaptchaEnabled) {
      const { executeRecaptcha } = this.props.googleReCaptchaProps;
      const token = await executeRecaptcha('login');
      user = { ...user, captcha: token, captchaRequired: captchaRequired };
    }
    */

    const validator = validateLogin(user);
    if (validator.isValid) {
      this.setState({ errorFlag: true });
      const resetTurnstile = () => this.turnstileRef.current?.reset();
      if (captchaRequired) {
        try {
          await this.props.loginWithCaptcha(user, trackEvent, referenceCode);
          this.props.mixpanel.track('Click Login Button', { 'Login Succesful/Fail Status': true });
        } catch (error) {
          this.setState({ errorFlag: false });
          this.props.mixpanel.track('Click Login Button', { 'Login Succesful/Fail Status': false });
        }
      } else {
        try {
          await this.props.loginUserV2(user, trackEvent, getLoginForm, referenceCode);
          this.props.mixpanel.track('Click Login Button', { 'Login Succesful/Fail Status': true });
          resetTurnstile();
        } catch (error) {
          this.setState({ errorFlag: false });
          resetTurnstile();
          this.props.mixpanel.track('Click Login Button', { 'Login Succesful/Fail Status': false });
        }
      }
    } else {
      this.setState({
        validationErrors: {
          ...validator.errors
        }
      });
      this.props.mixpanel.track('Click Login Button', { 'Login Succesful/Fail Status': false  });
    }
  };

  clearInput = fieldName => {
    this.setState({
      [fieldName]: '',
      validationErrors: {
        ...this.state.validationErrors,
        [fieldName]: ''
      }
    });
  };

  forgotPasswordOnClickHandler = () => {
    const { referenceCode, username } = this.state;

    this.props.mixpanel.track('Click Forgot Password Button');

    if (referenceCode) {
      History.push(`/sifremi-unuttum?referans-kod=${referenceCode}`, {
        identifier: username,
        referenceCode: referenceCode
      });
      
      this.props.mixpanel.track('Click Forgot Password', {
        'Reference Code': referenceCode
      });
      return;
    }

    History.push('/sifremi-unuttum');
  }

  render () {
    const { username, password, validationErrors, errorFlag, referenceCode } = this.state;
    const { error } = this.props.auth;

    
    const referenceCodeWelcomeMessage = EnvironmentManager.getMessageText({ key: 'reference_welcome_text' }) || 'Hoşgeldin Bilyonerli';

    const referenceCodeMessage = EnvironmentManager.getMessageText({ key: 'reference_login_page' });

    const submitButtonDisabled = username.length < FIELD_LENGTHS.USER_ID_MIN_LENGTH
      || password.length < FIELD_LENGTHS.USER_PASSWORD_MIN_LENGTH
      || (this.state.turnstileEnabled && !this.state.turnstileToken);
      

    return (
      <form className="form" onSubmit={ this.onSubmit }>
        <div className="form__row">
          <Input
            name="TC Kimlik veya Üye Numarası"
            id="username"
            type="text"
            inputMode="numeric"
            value={ username }
            maxLength={ FIELD_LENGTHS.USER_TC_NUMBER_MAX_LENGTH }
            autoFocus
            validateOnBlur
            onChange={ this.onChange }
            onBlur={ this.onBlur }
            clearInput={ this.clearInput }
            errorMessage={ errorMap[validationErrors.username] }
            disabled={ referenceCode && this.props.location?.state?.identifier }
          />
        </div>

        <div className="form__row">
          <div className="form__col form__col--70">
            <Input
              name="Şifre"
              id="password"
              type="password"
              value={ password }
              maxLength={ FIELD_LENGTHS.USER_PASSWORD_MAX_LENGTH }
              validateOnBlur
              onChange={ this.onChange }
              onBlur={ this.onBlur }
              clearInput={ this.clearInput }
              errorMessage={ errorMap[validationErrors.password] }
            />
          </div>
          <div className="form__col form__col--30">
            <div onClick={ this.forgotPasswordOnClickHandler } className="link-forgot-password" title="Şifremi Unuttum">
              Şifremi Unuttum
            </div>
          </div>
        </div>
        { referenceCode
          && <>
          <div className="form__row">
            <Input
              name="Referans Kodu"
              id="referenceCode"
              type="text"
              disabled
              value={ referenceCode }
              onChange={ this.onChange }
              onBlur={ this.onBlur }
            />
          </div>
          <div className='login-reference'>
            <div className='login-reference__title'>
              { referenceCodeWelcomeMessage }
            </div>
            <div>
              { referenceCodeMessage }
            </div>
          </div>
          </>
        }

        <TurnstileWidget
          ref={ this.turnstileRef }
          className="form__row"
          onToken={ token => this.setState({ turnstileToken: token }) }
          onEnabled={ () => this.setState({ turnstileEnabled: true }) }
        />

        { errorFlag ? <LottieLoader type="loading" loop={ true } autoplay width="50px" /> :   <p className="text-error">{ error }</p> }
    
        <div className="form__row margin-top-10">
          <Button
            title={ 'GİRİŞ YAP' }
            className="btn btn--primary btn--block"
            type='submit'
            disabled={ submitButtonDisabled }
          >
            GİRİŞ YAP
          </Button>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, { loginUserV2, loginWithCaptcha })(withMixpanel(LoginForm));
// export default connect(mapStateToProps, { loginUserV2, loginWithCaptcha })(withGoogleReCaptcha(withMixpanel(LoginForm)));
